export const ROLE_NAMES = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  TENANT_ADMIN: 'TENANT_ADMIN',
  STUDIO_EXPERT: 'STUDIO_EXPERT',
  DATA_MAP_EXPERT: 'DATA_MAP_EXPERT',
  DASHBOARD_EXPERT: 'DASHBOARD_EXPERT',
  INTEGRATION_EXPERT: 'INTEGRATION_EXPERT',
  TENANT_USER: 'TENANT_USER',
};
